import React from 'react';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.content}>
        <div style={styles.copyright}>
          <span style={styles.copyrightIcon}>🌱</span>
          <span style={styles.copyrightText}>&copy; {new Date().getFullYear()} FarmConnect</span>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#1e3a29', // Match sidebar
    color: 'white',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    boxShadow: '0 -1px 3px rgba(0, 0, 0, 0.15)',
    zIndex: 100,
    height: 'var(--footer-height)',
    backgroundImage: 'linear-gradient(to right, #1e3a29, #2a4a36)',
  },
  content: {
    maxWidth: '1400px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    padding: '0 1rem',
  },
  copyright: {
    margin: 0,
    fontSize: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    opacity: 0.9,
  },
  copyrightIcon: {
    fontSize: '0.85rem',
    marginRight: '0.5rem',
  },
  copyrightText: {
    letterSpacing: '0.5px',
  },
};

export default Footer;
